export const EMAIL_TEST_ID = "email-info";
export const PHONE_TEST_ID = "phone-info";
export const DELIVERY_METHOD_TEST_ID = "delivery-method";
export const SHIPPING_ADDRESS_TEST_ID = "shipping-address";
export const BILLING_ADDRESS_TEST_ID = "billing-address";
export const ADDRESS_LINE_TEST_ID = "address-line";
export const PAYMENT_METHOD_TEST_ID = "payment-method";

export const ORDER_CONFIRMATION_TEST_ID = "order-confirmation";
export const ORDER_NUMBER_TEST_ID = "order-number";
export const ORDER_DATE_TEST_ID = "order-date";
